import { Calendar } from 'vanilla-calendar-pro';

export default function initCalendar() {
  const calendarEl = document.querySelector('#schedule-calendar');
  if (!calendarEl) return;

  // Get current year
  const currentYear = new Date().getFullYear();

  // Generate popups configuration from HTML
  const popups = {};
  const courseCards = document.querySelectorAll('[data-course-calendar]');

  courseCards.forEach((card) => {
    const dateEl = card.querySelector('[data-calendar-date]');
    const timeEl = card.querySelector('[data-calendar-time]');

    // Skip cards without specific date or with "ANYTIME" date
    if (!dateEl || dateEl.textContent.trim() === 'ANYTIME') return;

    const dateText = dateEl.textContent.trim();
    const timeText = timeEl ? timeEl.textContent.trim() : '';
    const date = `${currentYear}-06-${dateText.replace(/[^0-9]/g, '')}`; // Convert "June 10th" to "YYYY-06-10"

    // Format the popup title
    const dateObj = new Date(date);
    const formattedTitle = dateObj
      .toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      })
      .replace(/(\d+)$/, (match) => {
        const day = parseInt(match);
        const suffix = ['th', 'st', 'nd', 'rd'][day % 10 > 3 || day > 20 ? 0 : day % 10];
        return `${day}${suffix}`;
      });

    popups[date] = {
      html: `
        <div class="calendar-popup">
          <div class="popup-title">${formattedTitle}</div>
          <div class="popup-time">${timeText}</div>
        </div>
      `,
      modifier: 'calendar-popup-wrapper',
    };
  });

  const calendar = new Calendar('#schedule-calendar', {
    type: 'multiple',
    settings: {
      lang: 'en',
      selection: {
        day: 'multiple',
      },
      selected: {
        weekdays: [2], // Tuesday
      },
    },
    selectedMonth: 5,
    selectedYear: currentYear, // Use current year here as well
    displayMonthsCount: 12,
    layouts: {
      months: '2x2',
    },
    popups,
    CSSClasses: {
      calendar: 'schedule-calendar',
      selectedDay: 'calendar-selected',
      today: 'calendar-today',
    },
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    weekday: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  });

  calendar.init();

  document.addEventListener('fancybox.complete', () => {
    calendar.reset();
    calendar.init();
  });

  const calendarEl2 = document.querySelector('#calendar');
  if (!calendarEl2) return;

  const enableDatesPath = calendarEl2.dataset.enableDates;

  const initCalendarWithEnabledDates = (enabledDates = []) => {
    const options = {
      disableAllDates: true,
      enableDates: enabledDates,
      selectedYear: currentYear,
      firstWeekday: 0,
    };

    const calendar2 = new Calendar('#calendar', options);
    calendar2.init();
  };

  if (!enableDatesPath) {
    initCalendarWithEnabledDates();
    return;
  }

  const loadEnabledDates = async () => {
    try {
      const response = await fetch(enableDatesPath);
      const data = response.ok ? await response.json() : [];

      let enabledDates = [];

      if (Array.isArray(data)) {
        enabledDates = data;
      } else if (data && Array.isArray(data.enableDates)) {
        enabledDates = data.enableDates;
      }

      initCalendarWithEnabledDates(enabledDates);
    } catch {
      initCalendarWithEnabledDates();
    }
  };

  loadEnabledDates();
}

